var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductivity = function SvgProductivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 76,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FC",
    stroke: "#D6E5F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92,
    d: "M83.877 9.71H5.082C2.828 9.71 1 11.556 1 13.833v56.924c0 2.277 1.828 4.123 4.082 4.123h78.795c2.255 0 4.082-1.846 4.082-4.123V13.833c0-2.277-1.828-4.123-4.082-4.123Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M19.463 23.994h-5.121a2.253 2.253 0 0 0-2.242 2.264v40.845a2.253 2.253 0 0 0 2.242 2.264h5.12a2.253 2.253 0 0 0 2.242-2.264V26.258a2.253 2.253 0 0 0-2.241-2.264ZM37.85 41.691h-5.122a2.253 2.253 0 0 0-2.242 2.264v23.147a2.253 2.253 0 0 0 2.242 2.264h5.121a2.253 2.253 0 0 0 2.242-2.264V43.955a2.253 2.253 0 0 0-2.242-2.264ZM56.228 28.742h-5.121a2.253 2.253 0 0 0-2.242 2.264v36.087a2.253 2.253 0 0 0 2.242 2.264h5.121a2.253 2.253 0 0 0 2.242-2.264V31.006a2.253 2.253 0 0 0-2.242-2.264ZM74.614 48.023h-5.12a2.253 2.253 0 0 0-2.243 2.264v16.806a2.253 2.253 0 0 0 2.242 2.264h5.121a2.253 2.253 0 0 0 2.242-2.264V50.287a2.253 2.253 0 0 0-2.242-2.264Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B2C9DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.012,
    d: "m12.556 44.389 5.34-.212 14.953 15.526 14.307-13.16 15.591 5.18 15.044-9.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M84.73 21.37c5.844 0 10.58-4.784 10.58-10.685C95.31 4.784 90.574 0 84.73 0c-5.842 0-10.579 4.784-10.579 10.685 0 5.902 4.737 10.685 10.58 10.685Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5F8FC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.012,
    d: "m80.123 6.037 9.194 9.296M89.317 6.037l-9.194 9.296"
  })));
};
export default SvgProductivity;